import { useRef, useState, useEffect } from "react";
import { EventAggregator } from "@parksandresorts/core";
import styles from "./waves-background-pattern.module.less";
import EventAttributeStore from "components/stores/event-attribute-store";

const WavesBackgroundPattern = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [scrollPositionInPercent, setScrollPositionInPercent] = useState<number>(0);

  const waveStyle = {
    transform: `translate3d(-${scrollPositionInPercent * 3}px, 0px, 0px)`,
  };

  const onScroll = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const windowHeight = EventAttributeStore.getCurrentWindowHeight();
      const numberOfPixelsPastTop = Math.abs(Math.round(rect.y - windowHeight));
      const percentage = Math.round(100 * (numberOfPixelsPastTop / windowHeight));
      setScrollPositionInPercent(percentage);
    }
  };

  useEffect(() => {
    const unsubscribeObject = EventAggregator.subscribe("onScroll", onScroll);
    return () => {
      unsubscribeObject.remove();
    };
  }, []);

  return (
    <div ref={ref} className={styles.backgroundWrapper}>
      <div className={styles.wavePattern}>
        <div className={styles.top} style={waveStyle}>
          <svg className={styles.wavePart} width="2048" height="115" viewBox="0 0 2048 115">
            <path
              fill="#73D5EF"
              fillRule="evenodd"
              d="M0.0331215589,10 C204.088137,10 279.038201,106.513022 490.165268,100 C701.292334,93.4869784 708.224059,0 939.286356,0 C1170.34865,0 1352.39774,105 1562.45437,110 C1772.511,115 1805.5199,10 2048.58544,10 C2210.62913,10 2210.47137,45 2048.11216,115 L0.0106683221,115 C-136.01104,45 -136.003556,10 0.0331215589,10 Z"
            />
          </svg>
          <svg className={styles.wavePart} width="2048" height="115" viewBox="0 0 2048 115">
            <path
              fill="#73D5EF"
              fillRule="evenodd"
              d="M0.0331215589,10 C204.088137,10 279.038201,106.513022 490.165268,100 C701.292334,93.4869784 708.224059,0 939.286356,0 C1170.34865,0 1352.39774,105 1562.45437,110 C1772.511,115 1805.5199,10 2048.58544,10 C2210.62913,10 2210.47137,45 2048.11216,115 L0.0106683221,115 C-136.01104,45 -136.003556,10 0.0331215589,10 Z"
            />
          </svg>
        </div>
        <div className={styles.bottom} />
      </div>
    </div>
  );
};

export default WavesBackgroundPattern;
